import { createFileRoute } from '@tanstack/react-router'
import SystemLogsViewer from '@/components/organisms/SystemLogsViewer'

export const Route = createFileRoute('/_authenticated/admin/system/logs')({
  component: SystemLogsViewer,
})
